var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    _vm._l(_vm.value, function(item) {
      return _c(
        "DIV",
        { key: item.id, staticClass: "d-flex flex-col" },
        [
          _c("ItpText", { attrs: { pre: "", text: item.message } }),
          _vm._v(" "),
          item.valid_from || item.valid_to
            ? _c("UcValidityPeriod", {
                staticClass: "ml-2",
                attrs: { from: item.valid_from, to: item.valid_to }
              })
            : _vm._e(),
          _vm._v(" "),
          item.max_displays != null
            ? _c(
                "DIV",
                {
                  staticClass: "ml-2",
                  attrs: {
                    title: _vm._f("pgettext")(
                      "Displays",
                      "TransactionNotesDisplay"
                    )
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(item.counter) +
                      " / " +
                      _vm._s(item.max_displays) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }